import { render, staticRenderFns } from "./EmployeeLedgerDetail.vue?vue&type=template&id=1dca3f4a&scoped=true"
import script from "./EmployeeLedgerDetail.vue?vue&type=script&lang=js"
export * from "./EmployeeLedgerDetail.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLedgerDetail.vue?vue&type=style&index=0&id=1dca3f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dca3f4a",
  null
  
)

export default component.exports